var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCashless = function SvgCashless(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.75 9.462v17.076q0 1.137-.788 1.924-.787.788-1.924.788H6.962q-1.138 0-1.924-.788-.788-.787-.788-1.924V9.462q0-1.137.787-1.924.789-.788 1.925-.788h23.076q1.137 0 1.924.788.788.787.788 1.924M6.5 12.606h24V9.462a.44.44 0 0 0-.144-.318.44.44 0 0 0-.318-.144H6.962a.44.44 0 0 0-.318.144.44.44 0 0 0-.144.318zm0 4.788v9.144q0 .174.144.318a.44.44 0 0 0 .318.144h23.076a.44.44 0 0 0 .318-.144.44.44 0 0 0 .144-.318v-9.144z"
  })));
};
export default SvgCashless;